
import type { Checklist } from '@/components/kanban/ChecklistManager';

export interface ChecklistStats {
  totalChecklists: number;
  totalItems: number;
  completedItems: number;
  completionPercentage: number;
}

export const parseChecklists = (cardData: any): Checklist[] => {
  try {
    if (typeof cardData.checklists === 'string') {
      return JSON.parse(cardData.checklists);
    }
    return cardData.checklists || [];
  } catch {
    return [];
  }
};

export const calculateChecklistStats = (checklists: Checklist[]): ChecklistStats => {
  const totalChecklists = checklists.length;
  const allItems = checklists.flatMap(cl => cl.items);
  const totalItems = allItems.length;
  const completedItems = allItems.filter(item => item.completed).length;
  const completionPercentage = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  return {
    totalChecklists,
    totalItems,
    completedItems,
    completionPercentage,
  };
};
